import { PDF_ELEMENT_HANDLER_DICTIONARY } from './pdf-types';
import { getScaledDimensions } from './helpers';
/**
 *  Pre-checker is mainly used for the things listed below.
 *    1. Do check the content fit in the space that is remain in the page
 *    2. Get repositioned x, y coordinates(Basically used to adjust alignments)
 *    3. Get adjusted width, height( for adapt the content based on page width)
 */

const PreCheckerDict:PDF_ELEMENT_HANDLER_DICTIONARY = {

    /** Image
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'Image': function(dataObject:any , x:number, y:number)  {
      let attributes = dataObject.attr;
      let { scaledWidth, scaledHeight} = getScaledDimensions(dataObject.dimensions, {
        width: attributes.width,
        height: attributes.height
      }, attributes.scaleBasedOn);
      let w = attributes.scale ? scaledWidth : attributes.width;
      let h = attributes.scale ? scaledHeight : attributes.height;

      // if scaled width is greater than  container width then we  re calculate it
      if(w > this.getContainerWidth()) {
        let newScaled  = getScaledDimensions(dataObject.dimensions, { width:  this.getContainerWidth() }, 'width');
        w = newScaled.scaledWidth;
        h = newScaled.scaledHeight;
      }
      let repositionedX = 0;
       if(attributes?.align){
        if(attributes?.align == 'center') {
          let widthRemainingAfterImagePaced = this.getContainerWidth() - w;
          repositionedX = widthRemainingAfterImagePaced/2 + this.getContainerStartWidth();
        }
        if(attributes?.align == 'right') {
          let widthRemainingAfterImagePaced = this.getContainerWidth() - w;
          repositionedX = widthRemainingAfterImagePaced + this.getContainerStartWidth();
        }
      }
      
      return  {
        preCheckedWidth : w,
        preCheckedHeight: h,
        preCheckedX: repositionedX,
        preCheckedY: y,
      }
      
    },

    /**
     * Text
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'Text': function(dataObject:any,  x:number, y:number)  {
      let attributes = dataObject.attr;
      let repositionedX = x;
      let [b , l,  t, r] = dataObject.attr.padding;
      let w =  this.doc.getTextWidth(dataObject.data);
      let dimension = this.doc.getTextDimensions(dataObject.data, {
        fontSize:  dataObject.attr.fontSize
      });
       if(attributes?.align){
        if(attributes?.align == 'center') {
          let widthRemainingAfterImagePlaced = this.getContainerWidth() - w;
          repositionedX = widthRemainingAfterImagePlaced/2 + this.getContainerStartWidth();
        }
        if(attributes?.align == 'right') {
          let widthRemainingAfterImagePlaced = this.getContainerWidth() - w;
          repositionedX = widthRemainingAfterImagePlaced -r + this.getContainerStartWidth();
        }
      } else {
        repositionedX = repositionedX + l;
      }
      return  {
        preCheckedWidth : dimension.w,
        preCheckedHeight: dimension.h,
        preCheckedX: repositionedX,
        preCheckedY: y,
      }
    },

    /**
     * Table
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'Table': function(dataObject:any,  x:number, y:number)  {
      return  {
        preCheckedWidth : 0,
        preCheckedHeight: 0,
        preCheckedX: x,
        preCheckedY: y,
      }
    },

    /**
     * Spacer
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'Spacer': function(dataObject:any,  x:number, y:number)  {
      return  {
        preCheckedWidth : dataObject.dimensions.width || 0,
        preCheckedHeight: dataObject.dimensions.height || 0,
        preCheckedX: x,
        preCheckedY: y,
      }
    },

     /**
     * Spacer
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
     'Line': function(dataObject:any,  x:number, y:number)  {
      return  {
        preCheckedWidth : dataObject.dimensions.width ||  this.getContainerWidth(),
        preCheckedHeight: dataObject.dimensions.height || this.SPACE_BETWEEN_CONTENT,
        preCheckedX: x,
        preCheckedY: y,
      }
    },


    /**
     * Audiometry Container
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'AudiometryContainer': function(dataObject:any,  x:number, y:number)  {
      const pageWidth = this.getPDFWidth(); 

      const cellWidth = 90; //audiometry card width
      const cellHeight = 50; //audiometry card height
      const lineHeight = 20;
      const cellPadding = 15;

     // scrappy logic fo find the cell width
        let itemCounts = dataObject.data.length;
        let itemPerRow = 0;
        let rowCount = 1;
        let _pW = pageWidth;
        let _iWf = 0;
        while(itemCounts > 0) {
          let width  = 0;
          if(_iWf == 0) {
            width  = cellWidth;
          } else{
            width  = cellWidth +   cellPadding;
          }
      
          if( _pW > width) {
            _pW = _pW - width;
            _iWf++;
          }  else {
            if(!itemPerRow) {
              itemPerRow = _iWf;
            }
            _iWf = 0;
            _pW = pageWidth;
            rowCount++;
          }    
          itemCounts--;
        }

        if(itemPerRow == 0) {
          itemPerRow =  dataObject.data.length
        }

      let numberOfRows = rowCount;
      return  {
        preCheckedWidth : this.getContainerWidth(),
        preCheckedHeight: numberOfRows * cellHeight + ((numberOfRows -1 ) * this.SPACE_BETWEEN_CONTENT),
        preCheckedX: x,
        preCheckedY: y,
      }
    },

    /**
     * KennedysBrandBox
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'KennedysBrandBox': function(dataObject:any,  x:number, y:number)  {
      let attributes = dataObject.attr;
      let repositionedX = x;
      let w =  dataObject.dimensions.width > this.getContainerWidth() ? this.getContainerWidth() : dataObject.dimensions.width;
      if(attributes?.align){
        if(attributes?.align == 'center') {
          let widthRemaining = this.getContainerWidth() - w;
          repositionedX = widthRemaining/2 + this.getContainerStartWidth();
        }
        if(attributes?.align == 'right') {
          let widthRemaining = this.getContainerWidth() - w;
          repositionedX = widthRemaining + this.getContainerStartWidth();
        }
      }
      return  {
        preCheckedWidth : w,
        preCheckedHeight: dataObject.dimensions.height,
        preCheckedX: repositionedX,
        preCheckedY: y,
      }
    },

     /**
     * FeaturedBox
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
     'FeaturedBox': function(dataObject:any,  x:number, y:number)  {
      let attributes = dataObject.attr;
      let repositionedX = x;
      let w =  dataObject.dimensions.width > this.getContainerWidth() ? this.getContainerWidth() : dataObject.dimensions.width;
      if(attributes?.align){
        if(attributes?.align == 'center') {
          let widthRemainingAfterTable = this.getContainerWidth() - w;
          repositionedX = widthRemainingAfterTable/2 + this.getContainerStartWidth();
        }
        if(attributes?.align == 'right') {
          let widthRemainingAfterTable = this.getContainerWidth() - w;
          repositionedX = widthRemainingAfterTable + this.getContainerStartWidth();
        }
      }

      return  {
        preCheckedWidth : w,
        preCheckedHeight: dataObject.dimensions.height,
        preCheckedX: repositionedX,
        preCheckedY: y,
      }
    },

    /**
     * FeaturedTable
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'FeaturedTable': function(dataObject:any,  x:number, y:number)  {
      let attributes = dataObject.attr;
      let repositionedX = x;
      let w =  dataObject.dimensions.width > this.getContainerWidth() ? this.getContainerWidth() : dataObject.dimensions.width;
      if(attributes?.tableAlign){
        if(attributes?.tableAlign == 'center') {
          let widthRemainingAfterTable = this.getContainerWidth() - w;
          repositionedX = widthRemainingAfterTable/2 + this.getContainerStartWidth();
        }
        if(attributes?.tableAlign == 'right') {
          let widthRemainingAfterTable = this.getContainerWidth() - w;
          repositionedX = widthRemainingAfterTable + this.getContainerStartWidth();
        }
      }

      return  {
        preCheckedWidth : w,
        preCheckedHeight: dataObject.dimensions.height,
        preCheckedX: repositionedX,
        preCheckedY: y,
      }
    },

    /**
     * WarningBox
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'WarningBox': function(dataObject:any,  x:number, y:number)  {
      // TODO
      // let attributes = dataObject.attr;
      // let repositionedX = x;
      // let w =  dataObject.dimensions.width > this.getContainerWidth() ? this.getContainerWidth() : dataObject.dimensions.width;
      // if(attributes?.tableAlign){
      //   if(attributes?.tableAlign == 'center') {
      //     let widthRemainingAfterTable = this.getContainerWidth() - w;
      //     repositionedX = widthRemainingAfterTable/2 + this.getContainerStartWidth();
      //   }
      //   if(attributes?.tableAlign == 'right') {
      //     let widthRemainingAfterTable = this.getContainerWidth() - w;
      //     repositionedX = widthRemainingAfterTable + this.getContainerStartWidth();
      //   }
      // }

      return  {
        preCheckedWidth :  dataObject.dimensions.width,
        preCheckedHeight:  dataObject.dimensions.height,
        preCheckedX: x,
        preCheckedY: y,
      }
    },

    /**
     * WarningBox
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'AdviceBox': function(dataObject:any,  x:number, y:number)  {
      // TODO
      // let attributes = dataObject.attr;
      // let repositionedX = x;
      // let w =  dataObject.dimensions.width > this.getContainerWidth() ? this.getContainerWidth() : dataObject.dimensions.width;
      // if(attributes?.tableAlign){
      //   if(attributes?.tableAlign == 'center') {
      //     let widthRemainingAfterTable = this.getContainerWidth() - w;
      //     repositionedX = widthRemainingAfterTable/2 + this.getContainerStartWidth();
      //   }
      //   if(attributes?.tableAlign == 'right') {
      //     let widthRemainingAfterTable = this.getContainerWidth() - w;
      //     repositionedX = widthRemainingAfterTable + this.getContainerStartWidth();
      //   }
      // }

      return  {
        preCheckedWidth :  dataObject.dimensions.width,
        preCheckedHeight:  dataObject.dimensions.height,
        preCheckedX: x,
        preCheckedY: y,
      }
    },
    
    /**
     * ColumnDivider
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'ColumnDivider': function(dataObject:any,  x:number, y:number)  {
      let width = this.getContainerWidth();
      let height = 0;
      
      // do the calculation to find height;
      let columns = dataObject.data.columns;

      for(let i = 1; i <= columns; i++) {
          let items = dataObject.data.segments[i];
          let segmentHeight = 0;
          let counter = 0;
          while(counter < items.length) {
              let content = items[counter];
              //if(content.genericType == "quantitative") {
                 // find height by pre-checking it
                 // we are only checking the height we can pass x, y whatever we want
                 // cause this have no effect
                 let { preCheckedHeight } = PreCheckerDict[content.type].bind(this)(content, x, y);
                 segmentHeight+= preCheckedHeight
              //} else {
                 // we need to find the height of those elements 

              //}
              counter++;
          }
          segmentHeight += (items.length - 1 ) * this.SPACE_BETWEEN_CONTENT;
          if(segmentHeight > height) {
            height = segmentHeight;
          }
      }

      return  {
        preCheckedWidth : width,
        preCheckedHeight: height,
        preCheckedX: x,
        preCheckedY: y,
      }
    }, 
    /**
     * Group
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'Group': function(dataObject:any,  x:number, y:number)  {
      let width = this.getContainerWidth();
      let height = 0;
      
      // do the calculation to find height;
      let items = dataObject.data;
      let counter = 0;
          while(counter < items.length) {
              let content = items[counter];
              //if(content.genericType == "quantitative") {
                 // find height by pre-checking it
                 // we are only checking the height we can pass x, y whatever we want
                 // cause this have no effect
                 let { preCheckedHeight } = PreCheckerDict[content.type].bind(this)(content, x, y);
                 height+= preCheckedHeight
              //} else {
                 // we need to find the height of those elements 

              //}
              counter++;
          }
        height += (items.length - 1) * this.SPACE_BETWEEN_CONTENT;
        return  {
        preCheckedWidth : width,
        preCheckedHeight: height,
        preCheckedX: x,
        preCheckedY: y,
      }
    }, 
  }

  export default PreCheckerDict;